import React, { useState } from "react";
import styles from "./Index.module.css";
import {
  Grid,
  List,
  ListItem,
  ListItemText,
  Hidden,
  ListItemIcon,
} from "@material-ui/core";
import Sidebar from "./sidebar";
import { Route, Link, BrowserRouter as Router, Switch } from "react-router-dom";
import Organization from "./Organization";
import Department from "./Department";
import Program_Type from "./Program_Type";
import Program_Mode from "./Program_Mode";
import Program from "./Program";
import Users from "./Users";
import Program_Outcome_Type from "./Program_Outcome_Type";
import Generic_Program_Outcomes from "./Generic_Program_Outcomes";
import Course_Type from "./Course_Type";
import Delivery_Method from "./Delivery_Method";
import Lab_Category from "./Lab_Category";
import Blooms_Domain from "./Blooms_Domain";
import Blooms_Level from "./Blooms_Level";
import Map_Level_Weightage from "./Map_Level_Weightage";
const Index = () => {
  return (
    <Router>
      <Grid container>
        <Hidden mdDown>
          <Grid item lg={3} className={styles.sidebarWrapper}>
            <Sidebar />
          </Grid>
        </Hidden>
        <Grid item lg={9}>
          <Switch>
            <Route exact path="/configuration" component={Organization} />
            <Route
              exact
              path="/configuration/department"
              component={Department}
            />
            <Route
              exact
              path="/configuration/program-type"
              component={Program_Type}
            />
            <Route
              exact
              path="/configuration/program-mode"
              component={Program_Mode}
            />
            <Route exact path="/configuration/program" component={Program} />
            <Route exact path="/configuration/users" component={Users} />
            <Route
              exact
              path="/configuration/program-outcome"
              component={Program_Outcome_Type}
            />
            <Route
              exact
              path="/configuration/generic-program-outcomes"
              component={Generic_Program_Outcomes}
            />
            <Route
              exact
              path="/configuration/course-type"
              component={Course_Type}
            />
            <Route
              exact
              path="/configuration/delivery-method"
              component={Delivery_Method}
            />
            <Route
              exact
              path="/configuration/lab-category"
              component={Lab_Category}
            />
            <Route
              exact
              path="/configuration/blooms-domain"
              component={Blooms_Domain}
            />
            <Route
              exact
              path="/configuration/blooms-level"
              component={Blooms_Level}
            />
            <Route
              exact
              path="/configuration/map-level-weightage"
              component={Map_Level_Weightage}
            />
          </Switch>
        </Grid>
      </Grid>
    </Router>
  );
};

export default Index;
